/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const verifyEmailInputDataSchema = z.object({
	code: z.string(),
	pendingAuthenticationToken: z.string(),
})

export type VerifyEmailInputDataSchema = z.infer<typeof verifyEmailInputDataSchema>
